export function isNavRouteActive(routePath: string | undefined, activeSegment: string | undefined): boolean {
  if (routePath == null) return false;
  return routePath.split("/")[0] === (activeSegment ?? "");
}
